import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Plus, X } from "lucide-react";

interface InlineWebsiteInputProps {
  entries: Array<{ url: string; label: string }>;
  onAdd: () => void;
  onRemove: (index: number) => void;
  onChange: (index: number, field: "url" | "label", value: string) => void;
}

const LABEL_OPTIONS = [
  "website",
  "linkedin",
  "twitter",
  "facebook",
  "instagram",
  "other",
] as const;

export function InlineWebsiteInput({
  entries,
  onAdd,
  onRemove,
  onChange,
}: InlineWebsiteInputProps) {
  return (
    <div className="space-y-2">
      <div className="flex flex-col gap-2">
        {entries.map((entry, index) => (
          <div key={index} className="flex items-center gap-2">
            <Select
              value={entry.label}
              onValueChange={(value) => onChange(index, "label", value)}
            >
              <SelectTrigger className="w-20 h-7 text-xs">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {LABEL_OPTIONS.map((option) => (
                  <SelectItem key={option} value={option} className="text-xs">
                    {option.charAt(0).toUpperCase() + option.slice(1)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <Input
              value={entry.url}
              onChange={(e) => onChange(index, "url", e.target.value)}
              placeholder="https://..."
              className="h-7 text-xs flex-1"
            />
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="h-7 w-7 shrink-0"
              onClick={() => onRemove(index)}
              disabled={entries.length <= 1}
            >
              <X className="h-3 w-3" />
            </Button>
          </div>
        ))}
      </div>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-7 text-xs text-muted-foreground px-1"
        onClick={onAdd}
      >
        <Plus className="h-3 w-3 mr-1" />
        Add another
      </Button>
    </div>
  );
}
